import { useEffect, useRef, useState } from 'react';
import BackupMenu from './BackupMenu.jsx';
import SyncStatus from './SyncStatus.jsx';
import { THEMES, THEME_LABEL } from './usePrefs.js';

const THEME_HINT = {
  system: 'following your system.',
  light: 'always light.',
  dark: 'always dark.'
};

const nextTheme = theme => THEMES[(THEMES.indexOf(theme) + 1) % THEMES.length];

export default function Topbar({ nav, go, space, spaces, prefs, setPrefs, syncStatus, onSyncNow }) {
  const isEditor = nav.view === 'editor';
  const [spaceMenu, setSpaceMenu] = useState(false);
  const picker = useRef(null);

  useEffect(() => {
    if (!spaceMenu) return;
    const onClick = e => { if (!picker.current?.contains(e.target)) setSpaceMenu(false); };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, [spaceMenu]);

  return (
    <header className="topbar">
      <div className="wordmark">Longhand</div>

      {isEditor && (
        <div className="crumbs">
          <button className="link-btn" onClick={() => go({ view: 'library', focus: false })}>‹ Library</button>
          <span className="crumb-sep">/</span>
          <div className="space-picker" ref={picker}>
            <button
              className="space-btn" aria-haspopup="menu" aria-expanded={spaceMenu}
              onClick={() => setSpaceMenu(v => !v)}
            >
              {space ? space.name : ''}<span className="caret">▾</span>
            </button>
            {spaceMenu && (
              <div className="menu" role="menu">
                {spaces.map(sp => (
                  <button
                    key={sp.id} role="menuitem"
                    className={'menu-item' + (sp.id === nav.spaceId ? ' is-active' : '')}
                    onClick={() => {
                      setSpaceMenu(false);
                      go({ spaceId: sp.id, docId: sp.docs[0]?.id ?? null, tool: 'write', mode: 'write' });
                    }}
                  >
                    <span className="name">{sp.name}</span>
                    <span className="kind">{sp.kind}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      <div className="spacer" />

      {syncStatus && <SyncStatus status={syncStatus} onSyncNow={onSyncNow} />}

      {/* Outside the editor-only block: the library is where you land at
          midnight, and the lamp switch has to be there too. */}
      <button
        className="ghost-btn theme-btn"
        title={'Theme: ' + THEME_HINT[prefs.theme] + ' Click for ' + THEME_LABEL[nextTheme(prefs.theme)].toLowerCase() + '.'}
        onClick={() => setPrefs({ theme: nextTheme(prefs.theme) })}
      >{THEME_LABEL[prefs.theme]}</button>

      <BackupMenu space={space} />

      {isEditor && (
        <>
          {/* On the write pane the star lives in the inspector's segment, next
              to Write and Edit. Everywhere else there is no segment, so it
              comes up here — one star on screen, wherever you are. */}
          {nav.tool !== 'write' && (
            <button
              className={'ghost-btn ask-btn' + (nav.ask ? ' is-on' : '')}
              title="Ask Claude about this space" aria-label="Ask Claude"
              aria-pressed={!!nav.ask}
              onClick={() => go({ ask: !nav.ask })}
            >&#10024;</button>
          )}
          <button
            className={'ghost-btn aa-btn' + (prefs.typeBar ? ' is-on' : '')}
            title="Page width, text size and line height"
            aria-pressed={!!prefs.typeBar}
            onClick={() => setPrefs({ typeBar: !prefs.typeBar })}
          >Aa</button>
          <button className="ghost-btn" title="Distraction-free writing" onClick={() => go({ focus: true })}>
            Focus
          </button>
        </>
      )}
    </header>
  );
}
